import Phaser from 'phaser'
import { GameContext } from '@/config/GameContext'
import { setGrid, setSymbolMap } from '@/config/SlotConfig'

/**
 * BootScene — 极简启动 scene
 *
 * 仅 preload 当前 game 自己的 loading bg，让 PreloadScene 立刻能用对应主题的
 * loading 屏；然后切到 PreloadScene 加载完整 manifest。
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' })
  }

  preload(): void {
    GameContext.init()
    const cfg = GameContext.config()
    // 切到当前 game 的 grid + symbol map（candy 6×5 / sakura 5×3）
    setGrid(cfg.grid)
    setSymbolMap(cfg.symbolToAsset)

    // 当前 game 自己的 loading bg。每个 game 的 manifest 必须给出一个 image
    // entry 跟 bgLoadingKey 同名；这里只挑出来先 fetch。
    const loadingKey = cfg.bgLoadingKey ?? cfg.bgMainKey
    const loadingEntry = cfg.images.find((i) => i.key === loadingKey)
    if (loadingEntry && !this.textures.exists(loadingKey)) {
      this.load.image(loadingEntry.key, loadingEntry.path)
    }
  }

  create(): void {
    document.title = GameContext.config().id === 'sakura'
      ? 'Sakura Neon Fortune'
      : 'Neon Candy Fortune'
    this.scene.start('PreloadScene')
  }
}
